/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Documents_Group_OtherInputs */

const cs_documents_group_other = /** @type {(inputs: Documents_Group_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ostatní`)
};

const en_documents_group_other = /** @type {(inputs: Documents_Group_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Other`)
};

/**
* | output |
* | --- |
* | "Other" |
*
* @param {Documents_Group_OtherInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_group_other = /** @type {((inputs?: Documents_Group_OtherInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Group_OtherInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_documents_group_other(inputs)
	return cs_documents_group_other(inputs)
});